/* eslint-disable max-len */
const React = require('react');
const { Dark, Default, Flat, Bootstrap } = require('./Images/Themes');
const { CountryOfOperationItems } = require('../utils/constants');

const defaultAdvancedColorsOptions = {
  textPrimaryColor: '',
  textSecondaryColor: '',
  inputBackgroundColor: '',
  formBackgroundColor: '',
  baseColor: '',
  baseColorFirstVariant: '',
  baseColorSecondVariant: '',
  errorColor: '',
  successColor: '',
  outlinePrimaryColor: '',
  outlineSecondaryColor: '',
  buttonTextColor: '',
  fontSizeExtraSmall: '',
  fontSizeSmall: '',
  fontSizeMedium: '',
  fontSizeLarge: '',
  fontSizeExtraLarge: '',
  fontWeightNormal: '',
  fontWeightSemiBold: '',
  formInputsTextTransform: '',
  inputVerticalPadding: '',
  inputHorizontalPadding: '',
  inputFocusedBoxShadow: '',
  inputErrorFocusedBoxShadow: '',
  inputBorderWidth: '',
  inputFocusedBorderWidth: '',
  borderRadiusSmall: '',
  borderRadiusMedium: '',
  borderRadiusLarge: '',
  borderRadiusFull: '',
  formPadding: '',
};

const defaultAdvancedTextOptions = {
  formTitle: '',
  emailSectionTitle: '',
  installmentsSectionTitle: '',
  cardholderName: {
    label: '',
    placeholder: '',
  },
  email: {
    label: '',
    placeholder: '',
  },
  cardholderIdentification: {
    label: '',
  },
  cardNumber: {
    label: '',
  },
  expirationDate: {
    label: '',
  },
  securityCode: {
    label: '',
  },
  selectInstallments: '',
  selectIssuerBank: '',
  formSubmit: '',
};

const defaultEmailOptions = {
  email: '',
  identification: {
    type: '',
    number: '',
  },
};

function componentProps(i18n, lang) {
  return {
    title: i18n.gettext('Card Payment Brick'),
    description: i18n.gettext('Construye y comprueba la experiencia visual en tiempo real. Cuando esté todo listo, descarga o copia el código generado para agregarlo a tu sitio web o compartirlo con un desarrollador.'),
    breadCrumbLevels: [
      {
        text: i18n.gettext('Documentación'),
        id: '1',
        href: `/developers/${lang}/docs`,
      },
      {
        text: i18n.gettext('Checkout Bricks'),
        id: '2',
        href: `/developers/${lang}/docs/checkout-bricks/landing`,
      },
      {
        text: i18n.gettext('Card Payment Brick'),
        id: '3',
        href: `/developers/${lang}/docs/checkout-bricks/card-payment-brick/introduction`,
      },
      {
        text: i18n.gettext('Demostración'),
        id: '4',
        disabled: true,
      },
    ],
    publicKey: 'APP_USR-7355677e-d3ce-43d8-89bf-99a4c74718ca',
    optionsDescription: i18n.gettext('Configuración básica'),
    mobileDescription: i18n.gettext('Ingresa a la Demostración en una computadora para hacer configuraciones más avanzadas y tener acceso al código generado.'),
    languages: [
      {
        description: i18n.gettext('Português'),
        value: 'pt',
      },
      {
        description: i18n.gettext('Español'),
        value: 'es',
      },
      {
        description: i18n.gettext('English'),
        value: 'en',
      },
    ],
    options: [
      {
        id: 'publicKey',
        type: 'dropdown',
        label: i18n.gettext('País de operación'),
        placeholder: i18n.gettext('País de operación'),
        trackingLabel: 'COUNTRY_OF_OPERATION',
        items: CountryOfOperationItems.getJsxItems(i18n),
        width: 'full',
      },
      {
        id: 'theme',
        type: 'dropdown',
        label: i18n.gettext('Tema'),
        placeholder: i18n.gettext('Tema'),
        trackingLabel: 'THEME',
        defaultValue: 'default',
        items: [
          { value: 'default', primary: i18n.gettext('Default'), icon: <Default /> },
          { value: 'dark', primary: i18n.gettext('Dark'), icon: <Dark /> },
          { value: 'bootstrap', primary: i18n.gettext('Bootstrap'), icon: <Bootstrap /> },
          { value: 'flat', primary: i18n.gettext('Flat'), icon: <Flat /> },
        ],
        width: 'full',
      },
      {
        id: 'paymentMethod',
        type: 'dropdownMulti',
        label: i18n.gettext('Medios de pago'),
        defaultValue: ['credit_card', 'debit_card'],
        trackingLabel: 'PAYMENT_METHODS',
        items: [
          { value: 'credit_card', primary: i18n.gettext('Crédito') },
          { value: 'debit_card', primary: i18n.gettext('Débito') },
        ],
        width: 'full',
      },
      {
        id: 'maxInstallments',
        type: 'dropdown',
        label: i18n.gettext('Número máximo de cuotas'),
        placeholder: i18n.gettext('Número máximo de cuotas'),
        message: i18n.gettext('Válido solo para pagos con tarjeta de crédito'),
        trackingLabel: 'MAXIMUM_NUMBER_OF_INSTALLMENTS',
        defaultValue: 1,
        width: 'full',
        items: [
          { value: 1, primary: `1 ${i18n.gettext('cuota')}` },
          { value: 2, primary: `2 ${i18n.gettext('cuotas')}` },
          { value: 3, primary: `3 ${i18n.gettext('cuotas')}` },
          { value: 4, primary: `4 ${i18n.gettext('cuotas')}` },
          { value: 5, primary: `5 ${i18n.gettext('cuotas')}` },
          { value: 6, primary: `6 ${i18n.gettext('cuotas')}` },
          { value: 7, primary: `7 ${i18n.gettext('cuotas')}` },
          { value: 8, primary: `8 ${i18n.gettext('cuotas')}` },
          { value: 9, primary: `9 ${i18n.gettext('cuotas')}` },
          { value: 10, primary: `10 ${i18n.gettext('cuotas')}` },
          { value: 11, primary: `11 ${i18n.gettext('cuotas')}` },
          { value: 12, primary: `12 ${i18n.gettext('cuotas')}` },
        ],
      },
      {
        id: 'showTitle',
        type: 'switch',
        trackingLabel: 'TITLE',
        topLabel: i18n.gettext('Mostrar en el layout'),
        label: i18n.gettext('Título'),
        width: 'full',
        defaultValue: true,
        checked: true,
      },
      {
        id: 'showPaymentButton',
        type: 'switch',
        trackingLabel: 'PAYMENT_BUTTON',
        label: i18n.gettext('Botón de pagar'),
        width: 'full',
        defaultValue: true,
        checked: true,
        tooltipContent: i18n.jsx.gettext('Asegúrate que el layout de tu sitio tenga un botón para hacer pago antes de personalizar tu Brick.{0}{1}Más información en la documentación{2}', {
          tags: {
            0: '<br><br>',
            1: `<a href="/developers/${lang}/docs/checkout-bricks/card-payment-brick/additional-customization/hide-element" rel="noopener noreferrer" target="_blank">`,
            2: '</a>',
          },
        }),
      },
    ],
    advancedOptionsDescription: i18n.gettext('Configuraciones avanzadas'),
    advancedOptions: [
      {
        id: 'customVariables',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Personaliza los colores con códigos hexadecimales'),
        linkDescription: i18n.gettext('Más información en la documentación'),
        linkUrl: 'docs/checkout-bricks/additional-content/modify-css-variables',
        defaultValue: JSON.stringify(
          defaultAdvancedColorsOptions,
          null,
          2,
        ),
      },
      {
        id: 'customTexts',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Cambiar textos'),
        linkDescription: i18n.gettext('Más información en la documentación'),
        linkUrl: 'docs/checkout-bricks/card-payment-brick/additional-customization/change-texts',
        defaultValue: JSON.stringify(
          defaultAdvancedTextOptions,
          null,
          2,
        ),
      },
      {
        id: 'payerInfo',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Configurar inicialización del Brick'),
        linkDescription: i18n.gettext('Más información en la documentación'),
        linkUrl: 'docs/checkout-bricks/card-payment-brick/additional-customization/initialize-data-on-the-bricks',
        defaultValue: JSON.stringify(
          defaultEmailOptions,
          null,
          2,
        ),
      },
    ],
  };
}

function getProps(i18n, lang) {
  return componentProps(i18n, lang);
}

module.exports = { getProps, defaultAdvancedColorsOptions, defaultAdvancedTextOptions, defaultEmailOptions };
